import * as _ from 'lodash'
import React from 'react';
import enums from '../enum';
import globalRelay, { WellKnownGlobalFunction } from '../globalRelay';
import * as actions from '../actions';
import * as contractorActions from '../contractorActions';
import * as jobActions from '../jobActions';import router from '../router';

import { ContactEditCore } from './contactEdit';
import AddressEdit from './addressEdit';
import JobNotes from './jobNotes';
import { Confirm, ContextMenu, CurrencyInput, Expander, PhoneInput, Popup, Spinner } from './sharedComponents';

import contactModel from '../models/contactModel';
import addressModel from '../models/addressModel';
import contractorModel from '../models/contractorModel';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';

import util from '../util';
import { DayPickerInput } from './dayPickerInput';
import { getCollection, getModel, ModelCollection } from 'Scripts/store';


const ContractorView = ({ job, contractor = contractorModel({}), title, builtAsOptions, builtAs, onBuiltAsChange, updateAtPath }) => {
	const primaryContact = contractor.primaryContact;
	const workNumber = (primaryContact && primaryContact.workPhoneNumber) ? primaryContact.workPhoneNumber : 'N/A';
	const mobileNumber = (primaryContact && primaryContact.mobilePhoneNumber) ? primaryContact.mobilePhoneNumber : 'N/A';

	const contactName = (primaryContact) ? primaryContact.fullName : '';

	return (
		<Expander title={ title || 'BUILDER' }>
			<div className="inner">
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td><strong>Company</strong></td>
							<td>{ contractor.name }</td>
							<td />
						</tr>
						<tr>
							<td />
							<td><strong>Primary Contact</strong></td>
							<td>{ contactName }</td>
							<td />
						</tr>
						<tr className={ !builtAs ? 'required' : '' }>
							<td />
							<td>
								<strong>Built as</strong>
							</td>
							<td>
								<select className="select" value={ builtAs } onChange={ onBuiltAsChange }>
									{ !builtAs ? <option key='select'>Select</option> : null }
									{ _.map(builtAsOptions, o => <option key={ o.value } value={ o.value }>{ o.name }</option>) }
								</select>
							</td>
							<td />
						</tr>
						<tr>
							<td />
							<td><strong>Builder's Job Reference</strong></td>
							<td><input type="text" value={ job.builderJobNumber } onChange={ e => updateAtPath('/builderJobNumber', e.target.value, { autoSave: false }) } onBlur={ e => updateAtPath('/builderJobNumber', e.target.value, { autoSave: true }) } /></td>
							<td />
						</tr>
					</tbody>
				</table>
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td><strong>Office Phone</strong></td>
							<td>{ workNumber }</td>
							<td />
						</tr>
						<tr>
							<td />
							<td><strong>Mobile Phone</strong></td>
							<td>{ mobileNumber }</td>
							<td />
						</tr>
					</tbody>
				</table>
			</div>
		</Expander>
	);
};

function formatEmployeeDisplayName (e) {
	if (e.inactive) {
		return `${e.fullName} (inactive)`;
	}

	return e.fullName;
}

function employeeIsSelectable (e, currentKey) {
	return !e.inactive || (currentKey && e.key === currentKey);
}

class PersonnelSection extends React.Component<any,any> {
	private _accountManagerHasBeenSet;
	
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();
		this._accountManagerHasBeenSet = false;
	}

	UNSAFE_componentWillReceiveProps () {
		this.setState(this.getStateFromProps());
	}

	getStateFromProps () {
		const { store, securityContext } = componentServices;
		const { job, isNewJob } = this.props;
		const newState = _.assign({ currentEmployeeIsDesigner: false }, this.state);

		const currentEmployee = securityContext.getCurrentEmployee();
		const employees = getCollection({ store, collection: ModelCollection.employees });
		const globalConfig = globalRelay.config!;
		const roleTitleTests = globalConfig.systemRoleEmployeeTitleTests;
		const coordinatorTests = roleTitleTests.coordinator;
		const estimatorTests = roleTitleTests.estimator;
		const fieldSupervisorTests = roleTitleTests.fieldSupervisor;
		const processorTests = roleTitleTests.processor;
		const designerTests = job.businessSegment === enums.businessSegments.Retail ? roleTitleTests.designer : roleTitleTests.accountManager;

		newState.coordinators = employees.filter(employee => {
			return employeeIsSelectable(employee, job.coordinatorKey) && _.reduce(coordinatorTests, (r, v) => {
				if (!r) {
					const test = new RegExp(v, 'i');
					r = test.test(employee.orgTitleKey);
				}
				return r;
			}, false);
		}).sortBy(e => e.fullName);

		newState.estimators = estimatorTests && employees.filter(employee => {
			return employeeIsSelectable(employee, job.estimatorKey) && _.reduce(estimatorTests, (r, v) => {
				if (!r) {
					const test = new RegExp(v, 'i');
					r = test.test(employee.orgTitleKey);
				}
				return r;
			}, false);
		}).sortBy(e => e.fullName);

		newState.fieldSupervisors = fieldSupervisorTests && employees.filter(employee => {
			return employeeIsSelectable(employee, job.fieldSupervisorKey) && _.reduce(fieldSupervisorTests, (r, v) => {
				if (!r) {
					const test = new RegExp(v, 'i');
					r = test.test(employee.orgTitleKey);
				}
				return r;
			}, false);
		}).sortBy(e => e.fullName);

		newState.processors = processorTests && employees.filter(employee => {
			return employeeIsSelectable(employee, job.processorKey) && _.reduce(processorTests, (r, v) => {
				if (!r) {
					const test = new RegExp(v, 'i');
					r = test.test(employee.orgTitleKey);
				}
				return r;
			}, false);
		}).sortBy(e => e.fullName);

		newState.designers = employees.filter(employee => {
			if (currentEmployee && currentEmployee.key === employee.key) {
				newState.currentEmployeeIsDesigner = true;
			}

			return employeeIsSelectable(employee, job.accountManagerKey) && _.reduce(designerTests, (r, v) => {
				if (!r) {
					const test = new RegExp(v, 'i');
					r = test.test(employee.orgTitleKey);
				}
				return r;
			}, false);
		}).sortBy(e => e.fullName);

		if (isNewJob && !this._accountManagerHasBeenSet && newState.currentEmployeeIsDesigner && !job.accountManagerKey) {
			job.accountManagerKey = currentEmployee.key;
		}

		return newState;
	}

	updateModel (path, autoSave, e) {
		e.preventDefault();

		// console.log('Personnel autosave: ', autoSave);
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		if (path === 'accountManagerKey') {
			this._accountManagerHasBeenSet = true;
		}

		this.props.updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	render () {
		const { job, title } = this.props;
		const { coordinators, estimators, fieldSupervisors, processors, designers } = this.state;

		// Configure the coordinator options
		const coordinatorOptions:JSX.Element[] = [];
		coordinatorOptions.push(<option key="unknown" value="">Select</option>);

		if (coordinators) {
			coordinators.forEach(e => {
				coordinatorOptions.push(<option key={e.key} value={e.key}>{formatEmployeeDisplayName(e)}</option>);
			});
		}

		// Configure the estimator options
		const estimatorOptions:JSX.Element[] = [];

		if (estimators) {
			estimatorOptions.push(<option key="unknown" value="">Select</option>);

			estimators.forEach(e => {
				estimatorOptions.push(<option key={e.key} value={e.key}>{formatEmployeeDisplayName(e)}</option>);
			});
		}

		// Configure the field supervisor options
		const fieldSupervisorOptions:JSX.Element[] = [];

		if (fieldSupervisors) {
			fieldSupervisorOptions.push(<option key="unknown" value="">Select</option>);

			fieldSupervisors.forEach(e => {
				fieldSupervisorOptions.push(<option key={e.key} value={e.key}>{formatEmployeeDisplayName(e)}</option>);
			});
		}

		// Configure the processor options
		const processorOptions:JSX.Element[] = [];

		if (processors) {
			processorOptions.push(<option key="unknown" value="">Select</option>);

			processors.forEach(e => {
				processorOptions.push(<option key={e.key} value={e.key}>{formatEmployeeDisplayName(e)}</option>);
			});
		}

		// Configure the designer options
		const designerOptions:JSX.Element[] = [];
		designerOptions.push(<option key="unknown" value="">Select</option>);

		if (designers) {
			designers.forEach(e => {
				designerOptions.push(<option key={e.key} value={e.key}>{formatEmployeeDisplayName(e)}</option>);
			});
		}

		return (
			<Expander title={ title }>
				<div className="inner">
					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td>
									<strong>Coordinator</strong>
								</td>
								<td>
									<select className="select" placeholder="Select" value={job.coordinatorKey} onChange={this.updateModel.bind(this, 'coordinatorKey', true)}>
										{ coordinatorOptions }
									</select>
								</td>
								<td />
							</tr>
							{ estimatorOptions.length ? <tr>
								<td />
								<td>
									<strong>Estimator</strong>
								</td>
								<td>
									<select className="select" placeholder="Select" value={job.estimatorKey} onChange={this.updateModel.bind(this, 'estimatorKey', true)}>
										{ estimatorOptions }
									</select>
								</td>
								<td />
							</tr> : null }
						</tbody>
					</table>
					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td>
									<strong>{ globalRelay.config!.getString('Designer', job.businessSegment === enums.businessSegments.Builder ? 'builder' : 'retail') }</strong>
								</td>
								<td>
									<select className="select" placeholder="Select" value={job.accountManagerKey} onChange={this.updateModel.bind(this, 'accountManagerKey', true)}>
										{ designerOptions }
									</select>
								</td>
								<td />
							</tr>
							{ processorOptions.length ? <tr>
								<td />
								<td>
									<strong>Processor</strong>
								</td>
								<td>
									<select className="select" placeholder="Select" value={job.processorKey} onChange={this.updateModel.bind(this, 'processorKey', true)}>
										{ processorOptions }
									</select>
								</td>
								<td />
							</tr> : null }
							{ fieldSupervisorOptions.length ? <tr>
								<td />
								<td>
									<strong>Field Supervisor</strong>
								</td>
								<td>
									<select className="select" placeholder="Select" value={job.fieldSupervisorKey} onChange={this.updateModel.bind(this, 'fieldSupervisorKey', true)}>
										{ fieldSupervisorOptions }
									</select>
								</td>
								<td />
							</tr> : null }
						</tbody>
					</table>
				</div>
			</Expander>
		);
	}
}

function findStatus (jobStatuses, status, parent?) {
	let result;

	_.forEach(jobStatuses, jobStatus => {
		if (jobStatus.key === status) {
			result = _.assign({}, jobStatus, { parent });
		}
		else if (jobStatus.manualStatuses && jobStatus.manualStatuses.length) {
			result = findStatus(jobStatus.manualStatuses, status, jobStatus);
		}

		if (result) {
			return false;
		}
	});

	return result;
}

function HomeownerContactSection ({ job, validateContact, updatePrimaryContact, updateSecondaryContact }) {
	return 	(<Expander title="HOMEOWNERS">
		<Expander title="PRIMARY HOMEOWNER">
			<ContactEditCore
				contact={ job.primaryClientContact || contactModel({ priority: 0 }) }
				validate={ validateContact }
				updateModel={ updatePrimaryContact } />
		</Expander>
		<Expander title="SECONDARY HOMEOWNER">
			<ContactEditCore
				contact={ job.secondaryClientContact || contactModel({ priority: 1 }) }
				validate={ validateContact }
				updateModel={ updateSecondaryContact} />
		</Expander>
	</Expander>);
}

function MarketingContact ({ contact }) {
	const additionalInfoRows = _.map(_.filter(contact.additionalInfo, i => ['source', 'source-url'].indexOf(i.name) === -1), i => {
		return (<tr key={ i.name }>
			<td />
			<td><strong>{ i.name }</strong></td>
			<td>{ i.value }</td>
			<td />
		</tr>);
	});

	return (<Expander title="Web Site Form" contentClassNames={ ['inner'] }>
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td />
					<td style={ { width: '18%' } }><strong>Date</strong></td>
					<td>{ util.dateHelper.formatDate(contact.dateCreated,{ format: 'MM/dd/yyyy' }) }</td>
					<td />
				</tr>
				<tr>
					<td />
					<td><strong>Source</strong></td>
					<td><a href={ contact.getAdditionalInfoValue('source-url', 'javascript:;') } target="_blank">{ contact.getAdditionalInfoValue('source', '-') }</a></td>
					<td />
				</tr>
				<tr>
					<td />
					<td><strong>First Name</strong></td>
					<td>{ contact.viewValue('firstName') }</td>
					<td />
				</tr>
				<tr>
					<td />
					<td><strong>Last Name</strong></td>
					<td>{ contact.viewValue('lastName') }</td>
					<td />
				</tr>
				<tr>
					<td />
					<td><strong>Email Address</strong></td>
					<td><a href={ `mailto:${contact.emailAddress}`}>{ contact.viewValue('emailAddress') }</a></td>
					<td />
				</tr>
				<tr>
					<td />
					<td><strong>Phone Number</strong></td>
					<td>{ contact.mobilePhoneNumber || '-' }</td>
					<td />
				</tr>
				{ additionalInfoRows }
			</tbody>
		</table>
	</Expander>);
}

class MarketingSection extends React.Component<any,any> {
	private _unmounting;

	constructor (props) {
		super(props);

		this.state = { leadSources: []};

		this.onDateChange = this.onDateChange.bind(this);
		this.onStatusChange = this.onStatusChange.bind(this);
	}

	componentDidMount () {
		this._unmounting = false;
		globalRelay.executeGlobalFunction(WellKnownGlobalFunction.GET_LEAD_SOURCES)
			.then(result => {
				if (!this._unmounting) {
					this.setState(previousState => { //eslint-disable-line react/no-did-mount-set-state
						const newState = _.assign({}, previousState);

						newState.leadSources = result;

						return newState;
					});
				}
			});
	}

	componentWillUnmount () {
		this._unmounting = true;
	}

	onDateChange ({ date }: { date?: Date }) {
		const newVal = date ? util.dateHelper.formatDate(date, { format: 'MM/dd/yyyy' }) : '';

		this.props.updateModel(model => {
			model.setSetting(enums.jobSettingGroups.Marketing, 'projectedOrderDate', newVal);
		}, { autoSave: true });
	}

	handleLeadSourceChange (e) {
		const val = e.target.value;

		this.props.updateModel(model => {
			model.leadSource = val;

			if (val.toLowerCase().indexOf('referral') === -1 ) {
				model.referralFrom = '';
			}
		}, { autoSave: true });
	}

	handleReferralFromChange (autoSave, e) {
		const val = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.referralFrom = val;

		}, { autoSave });
	}

	updateSetting (key, autoSave, e) {
		e.preventDefault();

		// console.log('Personnel autosave: ', autoSave);
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(model => {
			model.setSetting(enums.jobSettingGroups.Marketing, key, newVal);

		}, { autoSave });
	}

	onStatusChange (e) {
		const newVal = e.target.value;

		this.props.updateModel(model => {
			model.statusLog.add({ status: newVal });
		}, { autoSave: true });
	}

	render () {
		const { job } = this.props;
		const { leadSources } = this.state;
		const { jobStatuses } = componentServices.store.getIn(['model', 'domainEntities']);
		const currentStatus = findStatus(jobStatuses, job.currentStatus);
		const manualStatuses = (currentStatus.parent && currentStatus.parent.manualStatuses) || currentStatus.manualStatuses;
		const hubspotContactId = job.getSettingValue(enums.jobSettingGroups.Marketing, 'hubspotVid', '');
		const hubspotContactUrl = hubspotContactId ? globalRelay.config!.hubspot.contactUrlTemplate.replace('{0}', hubspotContactId) : null;
		const projectedOrderDateValue = job.getSettingValue(enums.jobSettingGroups.Marketing, 'projectedOrderDate');
		let statusElement = (<span className="readOnly">{ currentStatus.name }</span>);
		const marketingContacts = _.map(job.getExternalFormContacts(), c => {
			return <MarketingContact key={ c.key } contact={ c } />;
		});

		if (job.statusLog && manualStatuses && manualStatuses.length) {
			const parentStatus = currentStatus.parent || currentStatus;
			const statusOptions = _.map(manualStatuses, status => {
				return <option key={ status.key } value={ status.key }>{ status.name }</option>;
			});

			statusOptions.unshift(<option key={ parentStatus.key } value={ parentStatus.key }>{ parentStatus.name }</option>);

			statusElement = (<select className="select" placeholder="Select" value={ job.currentStatus } onChange={ this.onStatusChange }>{ statusOptions }</select>);
		}

		return (<Expander title="SALES &amp; MARKETING" classNames={ ['bringToFront'] }>
			<Expander title="OVERVIEW" classNames={ ['bringToFront'] } contentClassNames={ ['inner'] }>
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td><strong>Status</strong></td>
							<td>
								{ statusElement }
							</td>
							<td />
						</tr>
						<tr>
							<td />
							<td><strong>Projected Order Date</strong></td>
							<td>
								<DayPickerInput placeholder="Select a Date" selectedDate={ projectedOrderDateValue? new Date(projectedOrderDateValue): undefined } isVertical={ true } onDateSelected={ this.onDateChange } />
							</td>
							<td />
						</tr><tr>
							<td />
							<td><strong>Ballpark Budget</strong></td>
							<td><CurrencyInput placeholder="Ballpark Budget" autoCapitalize="" autoCorrect="off" value={ job.getSettingValue(enums.jobSettingGroups.Marketing, 'ballparkBudget', '0') } onChange={ this.updateSetting.bind(this, 'ballparkBudget', false) } onBlur={ this.updateSetting.bind(this, 'ballparkBudget', true) } /></td>
							<td />
						</tr>
					</tbody>
				</table>
				<table className="half" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td><strong>Contact Added</strong></td>
							<td><span className="readOnly">{ util.dateHelper.formatDate(job.dateCreated, { format: 'MM/dd/yyyy' }) }</span></td>
							<td />
						</tr>
						<tr className = { job.businessSegment === enums.businessSegments.Retail && !job.leadSource? 'required':''}>
							<td />
							<td><strong>Lead Source</strong></td>
							<td>
								<select className="select" value={ job.leadSource } onChange={ this.handleLeadSourceChange.bind(this) }>
									<option value="">Select</option>
									{ _.map(leadSources, source => <option key={ source.key } value={ source.key }>{ source.name }</option>) }
								</select>
							</td>
							<td />
						</tr>
						{ hubspotContactUrl
							? <tr>
								<td />
								<td><strong>Hubspot Contact</strong></td>
								<td><span className="readOnly"><a href={ hubspotContactUrl } target="_blank">View in Hubspot</a></span></td>
								<td />
							</tr>
							: <tr className={job.leadSource && job.leadSource.toLowerCase().indexOf('referral') !== -1 ? (job.referralFrom ? '' : 'required') : 'disabled'}>
								<td />
								<td><strong>Referral From</strong></td>
								<td><input type="text" className="" placeholder="Referral From" autoCapitalize="" autoCorrect="off" value={ job.referralFrom } onChange={ this.handleReferralFromChange.bind(this, false) } onBlur={ this.handleReferralFromChange.bind(this, true) } /></td>
								<td />
							</tr>
						}

					</tbody>
				</table>
			</Expander>
			{ marketingContacts }
		</Expander>);
	}
}

class ContactRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleContactChange = this.handleContactChange.bind(this);
	}

	handleContactChange (path, autoSave, e) {
		const { updateContact } = this.props;
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		updateContact((contact, options) => {
			if (path === 'workPhoneNumber') {
				contact.setPhoneNumber(enums.phoneNumberTypes.Work, newVal);
			}
			else if (path === 'description') {
				contact.setAdditionalInfo('description', newVal);
			}
			else {
				contact.setAt(path, newVal);
			}

			options.autoSave = true;
		});
	}

	render () {
		const { buttonClass, buttonAction, className, contact } = this.props;

		return (<tr className={ className }>
			<td />
			<td><input type="text" placeholder="First Name" autoCapitalize="" autoCorrect="off" value={ contact.viewValue('firstName')} onChange={this.handleContactChange.bind(this, 'firstName', false)} onBlur={this.handleContactChange.bind(this, 'firstName', true)} /></td>
			<td><input type="text" placeholder="Last Name" autoCapitalize="" autoCorrect="off" value={ contact.viewValue('lastName')} onChange={this.handleContactChange.bind(this, 'lastName', false)} onBlur={this.handleContactChange.bind(this, 'lastName', true)} /></td>
			<td><input type="text" placeholder="Email Address" autoCapitalize="" autoCorrect="off" value={ contact.viewValue('emailAddress')} onChange={this.handleContactChange.bind(this, 'emailAddress', false)} onBlur={this.handleContactChange.bind(this, 'emailAddress', true)} /></td>
			<td><PhoneInput placeholder="Phone" autoCapitalize="" autoCorrect="off" value={ contact.viewValue('workPhoneNumber') } onChange={this.handleContactChange.bind(this, 'workPhoneNumber', false)} onBlur={this.handleContactChange.bind(this, 'workPhoneNumber', true)} /></td>
			<td><input type="text" placeholder="Description" autoCapitalize="" autoCorrect="off" value={ contact.getAdditionalInfoValue('description', '')} onChange={this.handleContactChange.bind(this, 'description', false)} onBlur={this.handleContactChange.bind(this, 'description', true)} /></td>
			<td>{ buttonAction ? <button className={ `icon iconOnly ${buttonClass}` } onClick={ buttonAction }><span /></button> : null }</td>
			<td />
		</tr>);
	}
}

class OtherContactsSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { pendingContact: this.createPendingContact() };

		this.addContact = this.addContact.bind(this);
	}

	createPendingContact () {
		const { job } = this.props;
		const additionalContacts = _.filter(job.clientContacts.toArray(), c => !c.externalFormKey && c.priority > 1);

		return contactModel({ jobKey: job.key, priority: additionalContacts.length + 2 });
	}

	addContact () {
		const { updateModel } = this.props;
		const { pendingContact } = this.state;

		updateModel(job => {
			job.clientContacts.add(pendingContact);

			this.setState({ pendingContact: this.createPendingContact() });
		}, { autoSave: true });
	}

	onContextClick (item, e) {
		const { updateModel } = this.props;
		const doDelete = () => {
			updateModel(job => {
				job.clientContacts.delete(item.key);
				actions.popModal();
			}, { autoSave: true });
		};
		const popup = <Popup target={e.target}><ContextMenu items={ [{ label: 'Delete', className: 'removeItem delete', action: doDelete }] } /></Popup>;

		actions.pushModal({ component: popup });
	}

	updateModel (key, updater) {
		const { updateModel } = this.props;
		const { pendingContact } = this.state;
		const options = { autoSave: false };

		updateModel(job => {
			let contact = job.clientContacts[key];

			if (!contact) {
				contact = pendingContact;
			}

			updater(contact, options);

			if (contact === pendingContact) {
				options.autoSave = false;
			}
		}, options);
	}

	render () {
		const { job } = this.props;
		const { pendingContact } = this.state;
		const additionalContacts = _.sortBy(_.filter(job.clientContacts.toArray(), c => !c.externalFormKey && c.priority > 1), 'priority');
		const rows = _.map(additionalContacts, c => {
			return <ContactRow key={ c.key } className="added" contact={ c } buttonClass='contextMenu' buttonAction={ this.onContextClick.bind(this, c) } updateContact={ this.updateModel.bind(this, c.key) } />;
		});

		rows.unshift(<ContactRow key={ pendingContact.key } contact={ pendingContact } buttonClass='addItem' buttonAction={ this.addContact } updateContact={ this.updateModel.bind(this, pendingContact.key) } />);

		return 	(<Expander title="OTHER JOB CONTACTS">
			<div className="inner">
				<table className="compact" cellPadding="0" cellSpacing="0">
					<thead>
						<tr>
							<td />
							<td>First Name</td>
							<td>Last Name</td>
							<td>Email Address</td>
							<td>Phone</td>
							<td>Description</td>
							<td />
							<td />
						</tr>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
			</div>
		</Expander>);
	}
}

class DocumentsSection extends React.Component<any,any> {
	private _unmounting;

	constructor (props) {
		super(props);

		this.state = { documents: []};
	}
	componentDidMount () {
		this._unmounting = false;
		globalRelay.executeGlobalFunction(WellKnownGlobalFunction.GET_JOB_OVERVIEW_DOCUMENTS)
			.then(result => {
				if (!this._unmounting) {
					this.setState(previousState => { //eslint-disable-line react/no-did-mount-set-state
						const newState = _.assign({}, previousState);

						newState.documents = result || [];

						return newState;
					});
				}
			});
	}

	componentWillUnmount () {
		this._unmounting = true;
	}

	printDocument (key) {
		const { documents } = this.state;
		const doc = _.find(documents, { key });
		const { job } = this.props;
		const { store } = componentServices;
		const builder = job && job.builderKey && getModel({ store, collection: ModelCollection.contractors, key: job.builderKey });
		const Child = doc.component;
		const doPrint = () => {
			window.print();
			setTimeout(() => {
				actions.setPrintChildren(null);
			}, 200);
		};

		actions.setPrintChildren(() => <Child builder={ builder } job={ job } onReady={ doPrint } />);
	}

	render () {
		const { documents } = this.state;

		if (!documents.length) {
			return null;
		}

		const rows = _.map(documents, doc => {
			return (<tr key={doc.key}>
				<td />
				<td><label>{ doc.name }</label></td>
				<td className="action"><button className="icon iconOnly pdf" onClick={ this.printDocument.bind(this, doc.key) }><span /></button></td>
				<td />
			</tr>);
		});

		return 	(<Expander title="Documents">
			<div className="inner">
				<table className="compact" cellPadding="0" cellSpacing="0">
					<tbody>
						{ rows }
					</tbody>
				</table>
			</div>
		</Expander>);
	}
}

export default class JobOverviewEdit extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.handleDeleteClick = this.handleDeleteClick.bind(this);
		this.handleAddressBindClick = this.handleAddressBindClick.bind(this);
		this.handleBuiltAsChange = this.handleBuiltAsChange.bind(this);
		this.validateContact = this.validateContact.bind(this);
		this.validateAddress = this.validateAddress.bind(this);
		this.updateAtPath = this.updateAtPath.bind(this);
	}

	UNSAFE_componentWillReceiveProps (nextProps) {
		// console.log('-- JobOverviewEdit will receive props ' + (nextProps.job !== this.props.job));
		// the component may initially mount without a job, be sure we re-bind
		this.setState(this.getStateFromProps(nextProps));
	}

	getStateFromProps (props) {
		const { job, store } = props;
		const builder = (job && job.builderKey) ? getModel({ store, collection: ModelCollection.contractors, key: job.builderKey }): undefined;

		const state = _.assign({}, this.state, {
			builder: builder,
			bindAddresses: !!(job && job.billingAddress && enums.addressTypes.isSet(enums.addressTypes.Work_Site, job.billingAddress.type))
		});

		if (job && job.builderKey && !builder) {
			// be sure we've fetched this builder
			contractorActions.fetchContractor({ key: job.builderKey });
		}

		if (builder && builder.officeAddress && !job.billingAddress) {
			const clonedAddress = builder.officeAddress.clone();

			clonedAddress.type = enums.addressTypes.Billing;
			job.billingAddress = clonedAddress;
		}

		return state;
	}

	validateContact (contact, property) {
		// if this job has a builder, neither contact is required, otherwise the primary contact is required
		// if the contact has any key information, validate it
		const { job } = this.props;
		const primaryContact = (contact.priority === 0 || contact === job.primaryClientContact)

		if (!job.builderKey && primaryContact) {
			return contact.isValid(property);
		}else if(job.builderKey && primaryContact && (['customer-home'].indexOf(job.builtAs) !== -1)){
			return contact.isValid(property);
		}
		else if (!contact.isEmpty()) {
			return contact.isValid(property);
		}
		return true;
	}

	validateAddress (address, property) {
		// allow empty addresses if there are no estimates/contracts or this is not a customer home
		if (address.isEmpty()) {
			const { job } = this.props;
			const { store } = componentServices;
			const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts }).filter(jc => jc.jobKey === job.key);

			if (jobCosts.count() === 0) {
				return true;
			}
		}

		return address.isValid(property);
	}

	handleAddressBindClick (e) {
		const checked = e.target.checked;

		e.stopPropagation();

		if (checked !== this.state.bindAddresses) {
			this.updateModel('billingAddress', addressModel, m => {
				if (checked) {
					m.type = enums.addressTypes.set(enums.addressTypes.Work_Site, m.type);
				}
				else {
					m.type = enums.addressTypes.unset(enums.addressTypes.Work_Site, m.type);
				}
			}, { autoSave: true });
		}
	}

	handleBuiltAsChange (e) {
		const val = e.target.value;

		this.props.updateModel(model => {
			model.builtAs = val;
		}, { autoSave: true });
	}

	updateModel (path, factory, updater, options) {
		this.props.updateModel(model => {
			let updateTarget = model.getAt(path);

			if (!updateTarget) { // auto-create the child model if it doesn't exist
				updateTarget = factory();
				model.setAt(path, updateTarget);
			}
			updater(updateTarget);

			const billingBoundToWorkSite = (model.billingAddress && enums.addressTypes.isSet(enums.addressTypes.Work_Site, model.billingAddress.type));

			if (billingBoundToWorkSite) {
				// remove the old work site address if it is no longer needed
				const workSiteAddress = _.find(model.addresses, { type: enums.addressTypes.Work_Site });
				if (workSiteAddress) {
					model.addresses.delete(workSiteAddress.key);
				}
			}
		}, options);
	}

	updateSet (path, updater, options) {
		this.props.updateModel(model => {
			const updateTarget = model.getAt(path);

			updater(updateTarget);
		}, options);
	}

	updateAtPath (path, value, options) {
		this.props.updateModel(model => {
			model.setAt(path, value);
		}, options);
	}

	handleDeleteClick () {
		const { job } = this.props;

		if (job && this.canDelete()) {
			const popup = <Confirm title={ 'Permanently Delete Job?' } message={ 'Are you sure you want to permanently delete this Job? This cannot be undone.' } confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ this.doDelete.bind(this) } />;

			actions.popModal();
			actions.pushModal({ component: popup });
		}
	}

	doDelete (e) {
		const { job } = this.props;
		const modalKey = 'job-delete-spinner';

		e.preventDefault();

		actions.popModal();
		actions.pushModal({ key: modalKey, component: (<Spinner />) });

		const pathParts = componentServices.router.getPathSegments();
		componentServices.router.replaceHistory('/' + pathParts[0]);

		jobActions.deleteJob({ job })
			.finally(() => {
				actions.deleteModal({ key: modalKey });
			});
	}

	canDelete () {
		const moduleKey = router.currentState.params.modulekey;
		const securityContext = componentServices.securityContext;
		let result = securityContext.currentUserHasFeature(moduleKey, 'job-delete');

		if (result) {
			const { job } = this.props;
			const { store } = componentServices;
			const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts });

			if (jobCosts && jobCosts.size) {
				const contracts = jobCosts.count(jc => jc.jobKey === job.key && jc.isContract);

				result = !contracts;
			}
		}

		return result;
	}

	render () {
		const { job, isNewJob, ...childProps } = this.props;
		const { builder } = this.state;
		const billingAddressEdit = (<Expander title="BILLING ADDRESS"><AddressEdit address={ job.billingAddress || addressModel() } validate={ this.validateAddress } updateModel={this.updateModel.bind(this, 'billingAddress', addressModel)} /></Expander>);
		const workSiteAddressEdit = (<Expander options={ [<label key="addressBindBox" style={{ height: 'auto', lineHeight: 'inherit', marginLeft: '10px', fontSize: '14px', textTransform: 'none', display: 'inline' }}>
			<input type="checkbox" onClick={ this.handleAddressBindClick } checked={ this.state.bindAddresses } value={ job.key } readOnly={ true } />Same as Billing Address</label>
		] } title="JOB ADDRESS">
			<AddressEdit
				address={ job.workSiteAddress || addressModel() }
				validate={ this.validateAddress }
				updateModel={this.updateModel.bind(this, 'workSiteAddress', addressModel)}
				disabled={ this.state.bindAddresses }

			/></Expander>);
		const jobNotesEdit = isNewJob ? null : (<JobNotes key={ job.key } notes={ job.notes.filter(n => !n.type || n.type === 'general') } title="INTERNAL NOTES" tooltipText="Will not be displayed on any client documents" type={ 'general' } updateNotes={this.updateSet.bind(this, 'notes')} />);
		let builderViewer:any = null;
		const personnelTitle = `${globalRelay.config!.shortCompanyName} Personnel`;
		const personnelEdit = (<PersonnelSection title={ personnelTitle.toUpperCase() } job={job} isNewJob={ isNewJob } updateModel={this.props.updateModel}/>);

		if (job.builderKey) {
			const builtAsOptions = [{
				name: 'Customer Home',
				value: 'customer-home'
			}, {
				name: 'Show Home',
				value: 'show-home'
			}, {
				name: 'Spec Home',
				value: 'spec-home'
			}, {
				name: 'Design Center',
				value: 'design-center'
			}];

			builderViewer = <ContractorView contractor={ builder } job={ job } builtAsOptions={ builtAsOptions } builtAs={ job.builtAs } onBuiltAsChange={ this.handleBuiltAsChange } updateAtPath={ this.updateAtPath } title={ undefined } />;
		}

		return (
			<React.Fragment>
				<div className="contactInfo">
					{ personnelEdit }
					<MarketingSection job={ job } { ...childProps } />
					<HomeownerContactSection job={ job } validateContact={ this.validateContact } updatePrimaryContact={ this.updateModel.bind(this, 'primaryClientContact', () => contactModel({ priority: 0 })) } updateSecondaryContact={ this.updateModel.bind(this, 'secondaryClientContact', () => contactModel({ priority: 1 })) } />
					<OtherContactsSection job={ job } updateModel={ childProps.updateModel } />
					{ builderViewer }
					{ billingAddressEdit }
					{ workSiteAddressEdit }
					<DocumentsSection job={ job } />
					{ jobNotesEdit }
				</div>
				{ this.canDelete() ? <footer><div className="actions"><button className="labelOnly deleteItem" onClick={ this.handleDeleteClick }>Permanently Delete this Job</button></div></footer> : null }
			</React.Fragment>
		);
	}
}